'use client'

import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { AddressBookData } from '~/hooks/useAddressBook'
import { useRemoveContact } from '~/hooks/useContacts'

export const DeleteContactDialog = ({
  contact,
  onClose,
}: {
  contact: AddressBookData
  onClose: () => void
}) => {
  const { removeContact, isProcessing } = useRemoveContact(contact.address)

  return (
    <SplitsDialogContent
      id="deleteContactDialog"
      title={`Delete the entry "${contact.label}"?`}
      variant="destructive"
      isLoading={isProcessing}
      deleteButton={{
        text: 'Delete',
        onClick: () => removeContact(onClose),
        eventName: 'clickedDeleteContact',
      }}
    >
      <p>
        This entry will be removed from your address book. This action cannot be
        undone.
      </p>
    </SplitsDialogContent>
  )
}
